import ActionablePanel from '../ActionablePanel'

import { generateTransitionName } from '@/models/createWarehouseReceivingOrder/build-state-node'

import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import throttle from 'lodash/throttle'
import SystemSettingMixin from '@/mixins/systemSettings'

export default {
  components: {
    ActionablePanel
  },
  mixins: [SystemSettingMixin],
  props: {
    stepName: {
      type: String,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    complete: {
      type: Boolean,
      required: true
    },
    machine: {
      type: Object,
      required: true
    },
    editDisabled: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    StoreModuleName: ModuleName
  }),
  watch: {
    stepCollapsed: {
      async handler (val) {
        if (val && this.active) {
          await this.$nextTick()
          this.$el.scrollIntoView()
          const windowScrollY = window.scrollY

          if (Math.round(windowScrollY) <= this.$el.offsetTop) {
            const sticky = document.getElementsByClassName('save-bar')[0]
            const stickyOffsetHeight = sticky ? sticky.offsetHeight : 0
            window.scrollBy({
              top: -(stickyOffsetHeight + 45),
              behavior: 'smooth'
            })
          }

          this.$shipBobStore.dispatch(ModuleName + '/setStepCollapsed', false)
          this.machine.visited.add(this.currentStep)
        }
      },
      immediate: true
    }
  },
  computed: {
    hasWroParcelBoxLimit () {
      if (this.$shipBobStore?.getters?.isWroParcelBoxLimitDisabled) return false
      return this.wroParcelBox !== undefined && !isNaN(parseInt(this.wroParcelBox))
    },
    currentStateName () {
      return this.machine?.currentStateName() || ''
    },
    draft () {
      return this.$shipBobStore.getters[ModuleName + '/draft']
    },
    editWro () {
      return this.$shipBobStore.getters[ModuleName + '/editWro']
    },
    savingWro () {
      return this.$shipBobStore.getters.loading('savingWro')
    },
    spokesLoading () {
      return this.$shipBobStore.getters.loading('spokesLoading')
    },
    disableSave () {
      return this.currentStateName.indexOf('valid') < 0
    },
    stepCollapsed () {
      return this.$shipBobStore.getters[ModuleName + '/stepCollapsed']
    },
    wroLabelPurchaseFlag () {
      return this.$shipBobStore.getters.enableWroLabelPurchaseFeatureFlag
    },
    selectedLabelPurchaseType () {
      return this.$shipBobStore.getters[ModuleName + '/selectedLabelPurchaseType']
    },
    isShipbobLabelSelected () {
      return this.selectedLabelPurchaseType && this.selectedLabelPurchaseType.id === 1 && this.wroLabelPurchaseFlag
    },
    isDangerousGoodsPresent () {
      return this.$shipBobStore.getters[ModuleName + '/selectedProducts'].some(x => x.isDangerousGoods === true)
    },
    isWroCreated () {
      return this.$shipBobStore.getters[ModuleName + '/isWroCreated']
    }
  },
  async mounted () {
    await this.getSystemSetting('WroParcelBoxLimit', 'wroParcelBox')
  },
  methods: {
    transitionSave: throttle(function () {
      // eslint-disable-next-line no-invalid-this
      this.machine.transition('SAVE', this.draft)
    }, 500),
    transitionEdit (val) {
      this.machine.transition(generateTransitionName(this.stepName))
    },
    transitionInput (val) {
      this.machine.transition('INPUT', val)
    },
    transitionClear () {
      if (this.draft.wroCreated) this.machine.transition('EDIT_CLEAR')
      else this.machine.transition('CLEAR')
    },
    transitionCancel () {
      this.machine.transition('CANCEL')
    }
  }
}
